const Blockly = require('blockly');
const blocklyWorkspace = require('../../../src/blockDefinition/blocklyWorkspace');
const _block = Symbol('block');
let _ws;
let _tree;
let toolbox;
module.exports = class Builder {
    constructor(blockTypeName, title, properties, _namespaces) {
        let [hNodeTypeGroup, hNodeType] = blockTypeName.split('_');
        if (
            hNodeType !== 'TextLabel' &&
            ['formElement', 'workflowCriteriaElement'].includes(hNodeTypeGroup) &&
            (!properties || (!properties.propertyName && !properties.dropdownDisplayProperties))
        ) {
            throw new Error(
                `${title} does not have a 'propertyName'.  You must pass a 'propertyName' value in properties when creating formElements.`
            );
        }

        if (this.constructor.name === 'TestTree') {
            const namespaces = _namespaces || [
                { title: 'ns', prettyName: 'ns', relations: [{ title: 'rel', prettyName: 'rel' }] }
            ];
            toolbox = blocklyWorkspace.configureWorkspace(null, namespaces);
            _ws = null; // clear workspace between runs.
            _tree = this;
        }

        this[_block] = Builder.ws.newBlock(blockTypeName);
        let titleField = this[_block].getField('title');
        if (titleField) {
            this[_block].setFieldValue(title, 'title');
        }
        if (properties) {
            Object.keys(properties).forEach(propertyName => {
                try {
                    this[_block].setFieldValue(properties[propertyName], propertyName);
                } catch (err) {
                    throw new Error(
                        `There was a problem setting ${propertyName}.  Does the field exist on the block ${this[_block].type}?`
                    );
                }
            });
        }
    }

    /**
     * @returns {Blockly.Workspace}
     */
    static get ws() {
        if (!_ws) {
            const headlessWorkspace = new Blockly.Workspace(
                Blockly.Options({
                    collapse: true,
                    comments: false,
                    disable: true,
                    maxBlocks: Infinity,
                    trashcan: true,
                    horizontalLayout: false,
                    toolboxPosition: 'start',
                    css: true,
                    media: 'https://blockly-demo.appspot.com/static/media/',
                    rtl: false,
                    scrollbars: true,
                    sounds: true,
                    oneBasedIndex: true,
                    grid: { spacing: 20, length: 1, colour: '#888', snap: true },
                    move: {
                        scrollbars: {
                            horizontal: true,
                            vertical: true
                        },
                        drag: true,
                        wheel: true
                    },
                    zoom: {
                        controls: true,
                        wheel: true,
                        startScale: 1.0,
                        maxScale: 3,
                        minScale: 0.3,
                        scaleSpeed: 1.2,
                        pinch: true
                    },
                    toolbox
                })
            );
            _ws = headlessWorkspace;
        }
        return _ws;
    }
    static clearWorkspace() {
        _ws = null;
    }

    addChildBlock(childBlock, inputName = 'children', options) {
        if (options && options.collapsed) {
            this[_block].setCollapsed(true);
        }
        let parentConnection = this[_block].getInput(inputName).connection;
        let childConnection = childBlock.block.outputConnection
            ? childBlock.block.outputConnection
            : childBlock.block.previousConnection;
        parentConnection.connect(childConnection);
    }

    /**
     * @returns {Builder|undefined}
     */
    get tree() {
        return _tree;
    }

    /**
     * @returns {Blockly.Block}
     */
    get block() {
        return this[_block];
    }

    renderJson() {
        Blockly.JavaScript.init(Builder.ws);
        let result = Blockly.JavaScript.blockToCode(this[_block]);
        return JSON.parse(result);
    }
};
